import logo from '../logo.svg';

function Header() {
  return (
    <header className="border-b border-b-2 border-yellow-300 px-8 py-4">
      <div className="mx-auto max-w-3xl text-right">
        <img src={logo} className="App-logo " alt="logo" />
        <span className="bg-pink-500 text-white text-xl rotate-12 -mt-2 inline-block font-semibold px-2 py-1 rounded-full">
          KI Studio
        </span>
      </div>

      <div className="h-1 yellow-400"></div>
    </header>
  );
}

export default Header;
